/** PROSPECTS */
export const GET_PAGING_PROSPECTIVE_HUB = 'GET_PAGING_PROSPECTIVE_HUB';
export const GET_PAGING_PROSPECTIVE_HUB_SUCCESS = 'GET_PAGING_PROSPECTIVE_HUB_SUCCESS';
export const GET_PAGING_PROSPECTIVE_HUB_ERROR = 'GET_PAGING_PROSPECTIVE_HUB_ERROR';
